import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { defineComponent as M, computed as i, openBlock as c, createElementBlock as l, normalizeStyle as V, createElementVNode as v, createCommentVNode as z, normalizeClass as E } from "vue";
const H = ["media", "srcset", "sizes"], N = ["media", "srcset", "sizes"], I = ["media", "srcset", "sizes"], Q = ["media", "srcset", "sizes"], X = ["srcset", "sizes"], q = ["srcset", "sizes"], A = ["srcset", "sizes"], G = ["alt", "src", "loading", "fetchpriority", "aria-hidden"], T = /* @__PURE__ */ M({
  __name: "LandingImageComponent",
  props: {
    images: {},
    useBannerCrop: {
      type: Boolean,
      default: !1
    },
    ratio: {
      default: ""
    },
    radius: {
      default: ""
    },
    alt: {
      default: ""
    },
    renderedSizes: {
      default: () => ({
        mobile: "100vw",
        desktop: "100vw"
      })
    },
    lazyLoad: {
      type: Boolean,
      default: !0
    },
    fetchPriority: {
      default: ""
    },
    customClasses: {
      default: ""
    },
    ariaHidden: {
      type: Boolean,
      default: !1
    },
    objectFit: {
      default: "cover"
    },
    useResizing: {
      type: Boolean,
      default: !0
    }
  },
  setup(k, {
    expose: x
  }) {
    const y = [350, 550, 700, 800, 900], g = y.concat([1200, 2e3]), S = g, f = S.concat([3e3, 4e3]), o = (e = [], t = "", {
      isLowDensity: n = !1
    } = {}) => e.reduce((a, R) => `${a}${t}?im=Resize,width=${R}${n ? "&density=1x" : ""} ${R}w,`, ""), s = k, B = i(() => ({
      "--ratio": s.ratio,
      "--object-fit": s.objectFit,
      "--radius": s.radius
    })), C = i(() => s.lazyLoad ? "lazy" : void 0), h = i(() => {
      var e;
      return (e = s.fetchPriority) != null && e.length ? s.fetchPriority : null;
    }), _ = i(() => {
      var n, a;
      const {
        vertical: e,
        original: t
      } = ((a = (n = s.images) == null ? void 0 : n.xs) == null ? void 0 : a.renditions) || {};
      return s.useBannerCrop && (e != null && e.src) ? e == null ? void 0 : e.src : t == null ? void 0 : t.src;
    }), d = i(() => {
      var n, a;
      const {
        vertical: e,
        original: t
      } = ((a = (n = s.images) == null ? void 0 : n.sm) == null ? void 0 : a.renditions) || {};
      return s.useBannerCrop && (e != null && e.src) ? e == null ? void 0 : e.src : t == null ? void 0 : t.src;
    }), m = i(() => {
      var n, a;
      const {
        wide: e,
        original: t
      } = ((a = (n = s.images) == null ? void 0 : n.md) == null ? void 0 : a.renditions) || {};
      return s.useBannerCrop && (e != null && e.src) ? e == null ? void 0 : e.src : t == null ? void 0 : t.src;
    }), r = i(() => {
      var n, a;
      const {
        wide: e,
        original: t
      } = ((a = (n = s.images) == null ? void 0 : n.lg) == null ? void 0 : a.renditions) || {};
      return s.useBannerCrop && (e != null && e.src) ? e == null ? void 0 : e.src : t == null ? void 0 : t.src;
    }), b = i(() => s.useResizing ? o(y, _.value) : _.value), $ = i(() => s.useResizing ? o(g, d.value) : d.value), L = i(() => s.useResizing ? o(S, m.value) : m.value), D = i(() => s.useResizing ? o(f, r.value) : r.value), P = i(() => s.useResizing ? o(g, d.value, {
      isLowDensity: !0
    }) : d.value), j = i(() => s.useResizing ? o(S, m.value, {
      isLowDensity: !0
    }) : m.value), F = i(() => s.useResizing ? o(f, r.value, {
      isLowDensity: !0
    }) : r.value), u = i(() => {
      var e;
      return ((e = s.renderedSizes) == null ? void 0 : e.mobile) || "100vw";
    }), w = i(() => {
      var e;
      return ((e = s.renderedSizes) == null ? void 0 : e.desktop) || "100vw";
    }), p = i(() => s.useResizing ? " and (-webkit-min-device-pixel-ratio: 1.5)" : "");
    return x({
      computedFetchPriority: h
    }), (e, t) => (c(), l("picture", {
      "data-ui": "landing-image-component",
      class: "landing-image-component",
      style: V(B.value)
    }, [v("source", {
      media: `(max-width: 767px)${p.value}`,
      srcset: b.value,
      sizes: u.value
    }, null, 8, H), v("source", {
      media: `(min-width: 1232px)${p.value}`,
      srcset: D.value,
      sizes: w.value
    }, null, 8, N), v("source", {
      media: `(min-width: 992px)${p.value}`,
      srcset: L.value,
      sizes: u.value
    }, null, 8, I), v("source", {
      media: `(min-width: 768px)${p.value}`,
      srcset: $.value,
      sizes: u.value
    }, null, 8, Q), e.useResizing ? (c(), l("source", {
      key: 0,
      media: "(min-width: 1232px) and (-webkit-device-pixel-ratio: 1)",
      srcset: F.value,
      sizes: w.value
    }, null, 8, X)) : z("", !0), e.useResizing ? (c(), l("source", {
      key: 1,
      media: "(min-width: 992px) and (-webkit-device-pixel-ratio: 1)",
      srcset: j.value,
      sizes: u.value
    }, null, 8, q)) : z("", !0), e.useResizing ? (c(), l("source", {
      key: 2,
      media: "(-webkit-device-pixel-ratio: 1)",
      srcset: P.value,
      sizes: u.value
    }, null, 8, A)) : z("", !0), r.value ? (c(), l("img", {
      key: 3,
      ref: "img",
      alt: e.alt,
      src: `${r.value}`,
      loading: C.value,
      fetchpriority: h.value,
      class: E(["landing-image-component__image", e.customClasses]),
      "aria-hidden": e.ariaHidden
    }, null, 10, G)) : z("", !0)], 4));
  }
});
export {
  T as default
};
